import { Type } from '@src/main/modules/parameters/domain/issues/category.interface';
import { TypeRepository } from '@src/main/modules/parameters/domain/issues/type.repository';
import {
  CreateTypeRequest,
  UpdateTypeRequest,
} from '@src/main/modules/parameters/infrastructure/dto/createUpdateCategoryRequest';
import {
  toType,
  TypeEntity,
} from '@src/main/modules/parameters/infrastructure/entity/category.entity';
import { api, TokenProvider } from '@src/main/shared/infrastructure/entity/axios';

const typesPath = '/types';

export const createTypeHttpRepository = (tokenProvider: TokenProvider): TypeRepository =>
  new TypeHttpRepository(tokenProvider);

class TypeHttpRepository implements TypeRepository {
  private readonly tokenProvider: TokenProvider;

  constructor(tokenProvider: TokenProvider) {
    this.tokenProvider = tokenProvider;
  }

  private async getAuthToken(): Promise<string> {
    const token = await this.tokenProvider.getToken();
    if (!token) throw new Error('Authentication token is missing');
    return token;
  }

  async findAll(): Promise<Type[]> {
    const token = await this.getAuthToken();
    const response = await api.get<TypeEntity[]>(`${typesPath}/all`, token);
    return response.map(toType);
  }

  async findById(id: string): Promise<Type> {
    const token = await this.getAuthToken();
    const response = await api.get<TypeEntity>(`${typesPath}/${id}`, token);
    return toType(response);
  }

  async create(type: CreateTypeRequest): Promise<Type> {
    const token = await this.getAuthToken();
    const response = await api.post<TypeEntity>(typesPath, token, type);
    return toType(response);
  }

  async update(id: string, type: UpdateTypeRequest): Promise<Type> {
    const token = await this.getAuthToken();
    const response = await api.put<TypeEntity>(`${typesPath}/${id}`, token, type);
    return toType(response);
  }

  async delete(id: string): Promise<void> {
    const token = await this.getAuthToken();
    await api.delete(`${typesPath}/${id}`, token);
  }
}
